import "./footer.css";
const Footer = () => {
  return (
    <>
      <footer>
        <p>Copyright &copy; Easy Coding</p>
      </footer>
    </>
  );
};
export default Footer;
